import { render, staticRenderFns } from "./Switches.vue?vue&type=template&id=cfdb2e54&"
import script from "./Switches.vue?vue&type=script&lang=js&"
export * from "./Switches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfdb2e54')) {
      api.createRecord('cfdb2e54', component.options)
    } else {
      api.reload('cfdb2e54', component.options)
    }
    module.hot.accept("./Switches.vue?vue&type=template&id=cfdb2e54&", function () {
      api.rerender('cfdb2e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/Switches.vue"
export default component.exports